import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBox, FDPrimaryActionButton, FDStack, FDTextButton,
} from '@facet-wealth/design';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { dataAttrs } from 'Helpers/Testing';
import { DialogActions, DialogContent, DialogTitle } from 'Views/Page/Content/Modal/Components';
import WizardStepDeleteButton from 'Views/Page/Content/Modal/Layouts/DefaultFDWizardStep/Layout/WizardStepDeleteButton';
import { useModalContextSubmissionSuccessful } from 'Hooks/useRefreshEvent';

function Layout() {
  const { onSubmit, resource, saving } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();
  const { refreshPageContentCollection } = usePageContentContext();
  const { displayErrorMessage } = useSnackbarContext();

  const handleCancel = () => {
    clearModalCollection();
  };

  useModalContextSubmissionSuccessful((evt, clearModalCollectionDependency) => {
    clearModalCollectionDependency();
    refreshPageContentCollection();
  }, [clearModalCollection]);

  const onDelete = async () => {
    try {
      await resource.delete();
    } catch (err) {
      displayErrorMessage(err, err.message);
    }
  };

  // If we delete the account or unlink the institution we want to close the modal and refresh the page collection
  const onDeleteSuccess = () => {
    clearModalCollection();
    refreshPageContentCollection();
  };

  const deleteOrHideMessage = !resource.attr('accountAggregatorMetaId')
    ? 'Removing this account will delete all of its information. This cannot be undone.'
    : 'Removing this account will hide the account and exclude the balance from totals.';

  return (
    <>
      <DialogTitle value={'Edit account'} />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction={'column'} alignItems={'stretch'} spacing={2}>
          <MetaControlField attr={'institution'} />
          <MetaControlField attr={'accountType'} />
          <MetaControlField attr={'type'} />
          <MetaControlField attr={'name'} />
          <MetaControlField attr={'balance'} />
          <MetaControlField attr={'ownerClientId'} />
          <MetaControlField attr={'owner'} />

          <MetaLayoutRemainingFields />

          <FDBox alignSelf={'center'}>
            <WizardStepDeleteButton
              onDelete={onDelete}
              onDeleteSuccess={onDeleteSuccess}
              dialogProps={{
                title: 'Are you sure?',
                message: deleteOrHideMessage,
                cancelLabel: 'Cancel',
                confirmLabel: 'Confirm',
              }}
            />
          </FDBox>
        </FDStack>
      </DialogContent>
      <DialogActions>
        <FDTextButton
          onClick={handleCancel}
          disabled={saving}
          label="Cancel"
        />
        <FDPrimaryActionButton
          onClick={onSubmit}
          label="Submit"
          loading={saving}
          {...dataAttrs('account-submit-btn')}
        />
      </DialogActions>
    </>
  );
}

Layout.defaultProps = {
};

Layout.propTypes = {
};

export default Layout;
